module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0155.jpg?v=42720dcf";